import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CityCard({ name, days, startDate, endDate, hotel, onClick }) {
    const { t, i18n } = useTranslation();
    const locale = i18n.language === 'en' ? 'en-US' : 'it-IT';
    const startFmt = new Date(startDate).toLocaleDateString(locale, { day: 'numeric', month: 'short' });
    const endFmt   = new Date(endDate).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
    const daysCount = days.length;

    return (
        <div
            onClick={onClick}
            className="card p-5 flex flex-col gap-3 cursor-pointer hover:shadow-lg hover:scale-[1.02] transition-all duration-200"
        >
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">{name}</h3>
                <span className="badge bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300">
                    {t('cityCard.days', { count: daysCount })}
                </span>
            </div>

            <p className="text-sm text-gray-600 dark:text-gray-400">
                {startFmt} — {endFmt}
            </p>

            {hotel?.name && hotel?.address && (
                <div className="bg-primary-50 dark:bg-primary-900/20 rounded-xl p-3">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">🏨 {hotel.name}</p>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{hotel.address}</p>
                </div>
            )}

            <button className="btn-outline text-sm w-full mt-1">
                {t('cityCard.viewDetails')}
            </button>
        </div>
    );
}
